export default __webpack_public_path__ + "static/media/sparck-mfa.b7a78a7f.png";